import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CoreService } from '../../services'
import { User } from 'depoto-core/src/entities'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @Input() isShown = false
  @Output() isBaseModalLoadedChange: EventEmitter<boolean> = new EventEmitter<boolean>()
  companyName = ''
  server = 'prod-hs'
  iconExpand = true
  windowWidth = window.innerWidth

  constructor(private core: CoreService) {
    this.core.services.user.currentUserEmitter.subscribe().then((user: User) => {
      if (user && user.company && user.company.name) {
        this.companyName = window['companyName'] = user.company.name
        document.title += ' [' + window['companyName'] + ']'
      } else {
        this.companyName = window['companyName'] = ''
        document.title = 'Evidentist'
      }
      this.server = this.core.services.oauth.session.clientType
    })
  }

  toggleSideMenu(): void {
    this.iconExpand = !this.iconExpand
    setTimeout(() => {
      if (document.getElementsByTagName('body')[0].className.includes('collapse')) {
        this.core.services.storage.set(this.core.services.storage.keys.app.sideMenuState, 'collapsed')
      } else {
        this.core.services.storage.set(this.core.services.storage.keys.app.sideMenuState, 'open')
      }
    }, 500)
  }

  onResize(event) {
    this.windowWidth = event.target.innerWidth
  }

  isBaseModalLoadedChangeToFalse() {
    this.isBaseModalLoadedChange.emit()
  }
}
